// extracted by mini-css-extract-plugin
export default {"svgWrapper":"SvgWrapper_svgWrapper__ucKeb"};